import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnactListItemComponent } from './enact-list-item.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/modules/shared/shared.module';


@NgModule({
  declarations: [
    EnactListItemComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    SharedModule
  ],
  exports: [
    EnactListItemComponent
  ]
})
export class EnactListItemModule { }